import { AttributesMixin, define, Model } from "@type-r/models";
import { restfulIO } from "./endpoint";

export interface Participant extends AttributesMixin<typeof Participant> { }

@define
export class Participant extends Model {
    static endpoint = restfulIO('api/v1/participants/all');

    static attributes = {
        companyId: Number,
        productCode: String,
        role: String,
        platformCode: String,
        isActive: Boolean,
        createdOn: Date,
        createdBy: String,
        updatedOn: Date,
        updatedBy: String
    }
}